/*
 * Jira Ticket:
 * Created Date: Thu, 19th Mar 2020, 11:51:08 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

const emailEx = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/, 'i');

const isValidEmailTest = email => {
  return emailEx.test(email);
};

export const isValidEmail = email => {
  if (email && !isValidEmailTest(email)) {
    return 'validation.invalidEmail';
  }
};

export const isValidPhoneNumber = phoneNumber => {
  const phoneEx = new RegExp(/^\+[1-9]\d{1,14}$/, 'i');
  if (phoneNumber && !phoneEx.test(phoneNumber)) {
    return 'validation.invalidPhone';
  }
};

export const isValidUrl = url => {
  if (url) {
    try {
      new URL(url);
    } catch (error) {
      return 'validation.invalidUrl';
    }
  }
};

export const nonNegativeNonZeroInt = (num = 0) => {
  if (num !== null) {
    if (Number.isInteger(num)) {
      if (num <= 0) {
        return 'validation.positivieNonZeroInt';
      }
    } else {
      return 'validation.notAnInt';
    }
  } else {
    return 'ra.validation.required';
  }
};

export const nonNegativeInt = num => {
  if (num !== null) {
    if (Number.isInteger(num)) {
      if (num < 0) {
        return 'validation.positivieInt';
      }
    } else {
      return 'validation.notAnInt';
    }
  } else {
    return 'ra.validation.required';
  }
};

export const nonNegativeIntCappedAt20 = num => {
  if (num !== null) {
    if (Number.isInteger(num)) {
      if (num < 0) {
        return 'validation.positivieInt';
      }
      if (num > 20) {
        return 'validation.cappedAt20';
      }
    } else {
      return 'validation.notAnInt';
    }
  } else {
    return 'ra.validation.required';
  }
};

export const isValidCost = cost => {
  const DECIMAL_REGEX = /^\d+(?:\.\d{2})$/; //enforce 2 d.p.
  if (cost && !isNaN(cost)) {
    if (!DECIMAL_REGEX.test(cost)) return 'validation.notACurrency';
  } else {
    return 'ra.validation.required';
  }
};

export const validateLiveDate = (startDate, formData) => {
  if (startDate && formData) {
    if (startDate > formData.endDate) {
      return 'validation.afterEnd';
    }
  }
};

export const validateEndDate = (endDate, formData) => {
  if (endDate && formData) {
    if (endDate < formData.startDate) {
      return 'validation.beforeLive';
    }
  }
};

export const validateQualificationInput = qualificationList => {
  // note this should be a comma separated string - not an array
  if (qualificationList) {
    const commaSeparatedStringRegex = /^[\t ]*((\d+[\t ]*)(,([\t ]*\d+[\t ]*))*)?$/;
    if (!commaSeparatedStringRegex.test(qualificationList)) {
      return 'validation.qualificationIdsIncorrectFormat';
    }
  }
};

export const isValidCSV = (csv, translate) => {
  if (csv[csv.length - 1][0] === '') {
    return {
      result: false,
      data: [],
      error: 'error.inviteUser.noEmptyLine',
    };
  }
  for (let i = 0; i < csv.length; i++) {
    const record = csv[i];
    if (record.length > 1) {
      return {
        result: false,
        data: [],
        error: translate('error.inviteUser.invalidRecord', {
          record,
          lineNumber: i + 1,
        }),
      };
    }
    if (!isValidEmailTest(record[0])) {
      return {
        result: false,
        data: [],
        error: translate('error.inviteUser.invalidEmail', {
          data: record[0],
          lineNumber: i + 1,
        }),
      };
    }
  }
  const emailList = csv.map(record => record[0]);
  if (emailList.length > 50) {
    return {
      result: false,
      data: [],
      error: translate('error.inviteUser.maxEmailsReached', {
        emailListLength: emailList.length,
      }),
    };
  }
  return {
    result: true,
    data: csv.map(record => record[0]),
    error: null,
  };
};
